module.exports = __webpack_public_path__ + "static/media/logo-maker-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/logo-maker-icon.svg
// module id = 516
// module chunks = 0